import React, { FC, useCallback } from 'react'
import { Layout } from 'components/Layout'
import { CompleteTemplate } from 'components/Templates'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'

const SettingsTemporaryOpenComplete: FC = () => {
  const dispatch = useDispatch()
  const backToTop = useCallback(() => dispatch(push('/')), [dispatch])

  return (
    <Layout title={'完了 | 臨時営業日の修正'}>
      <CompleteTemplate
        iconPath={'/icon/done/notice.svg'}
        label={'臨時営業日の設定が\n完了しました。'}
        backToTop={backToTop}
      />
    </Layout>
  )
}

export default SettingsTemporaryOpenComplete
